import { gql } from '@apollo/client';

export const searchClosedMonths = gql`
  query searchClosedMonths(
    $keyword: String
    $pagination: PaginationInput!
    $orderBy: OrderByInput
    $closeTypes: [String!]
    $closedMonths: [Int!]
    $closingDateFrom: DateTime
    $closingDateTo: DateTime
  ) {
    reinsurance {
      searchClosedMonths(
        keyword: $keyword
        pagination: $pagination
        orderBy: $orderBy
        closeTypes: $closeTypes
        closedMonths: $closedMonths
        closingDateFrom: $closingDateFrom
        closingDateTo: $closingDateTo
      ) {
        paging {
          pageNumber
          pageSize
          totalCount
        }
        items {
          id
          closingTypeID
          closingType {
            id
            code
            title
            createdOn
            modifiedOn
          }
          closingReferenceNumber
          closingMonth
          closingYear
          closingPeriodFrom
          closingPeriodTo
          createdOn
          modifiedOn
          createdBy
          modifiedBy
        }
      }
    }
  }
`;


export const getMonthClosingTypeList = gql`
  query getMonthClosingTypeList {
    reinsurance {
      getMonthClosingTypeList {
        id
        code
        title
        createdOn
        modifiedOn
      }
    }
  }
`;